export function getFileNameFromContentDisposition(contentDisposition: string): string | null {
    // Expressão regular para extrair o nome do arquivo
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(contentDisposition);
  
    if (matches != null && matches[1]) {
      // Remove aspas do nome do arquivo, se houver
      return matches[1].replace(/['"]/g, '');
    }
  
    return null; // Retorna null se não encontrar o nome do arquivo
  }

export function getFileExtension(filename: string) {
  //encontra a posição do último ponto no nome do arquivo
  const lastDotIndex = filename.lastIndexOf('.');
  
  // se essa posição for menor que zero, ou seja, se não encontrar, retorna string vazia. 
  // se encontrar o ponto, retorna ele e tudo o que vem depois.
  return lastDotIndex < 0 ? '' : filename.substring(lastDotIndex);
}